import TitleComponent from "../components/common/TitleComponent";
import OurCompaniesSlider from "../components/slider/OurCompaniesSlider";

const OurCompaniesContent = () => {
  return (
    // <div className="bg-gray-100 py-6 lg:px-10 mt-2 mb-4">
    // <TitleComponent
    //   Title={"We Drive Innovation"}
    //   Subtitle={"Our Companies"}
    // />
    // <OurCompaniesSlider/>
    // </div>

    <>
      {/* <div className="bg-gray-50 py-8 lg:py-16 px-4 lg:px-8 mt-6 mb-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center"> */}

        <div className="bg-gray-100 py-1   mt-2 mb-4">
           <TitleComponent
            Title={"We Drive Innovation"}
            Subtitle={"Our Companies"}
          />

          <OurCompaniesSlider />
        </div>
         
        {/* </div>
      </div> */}
    </>
  );
};

export default OurCompaniesContent;
